import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';

import { coordinationQueryKeys } from './queryKeys';

export const useCoordinationProcessesQuery = (jobId: string | undefined) => {
  return useQuery({
    queryKey: jobId ? coordinationQueryKeys.processes(jobId) : [],
    queryFn: jobId
      ? async () => {
          const { data } = await fetchClient.GET(
            coordinationEndpoints.processes,
            {
              params: { path: { jobId } },
            },
          );
          return data;
        }
      : skipToken,
  });
};
